import { Fragment } from 'react';
import { Button } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { ColumnToggle, Search } from 'react-bootstrap-table2-toolkit';

const Reports = ({ users }) => {
    // function userTypeFormatter(cell, row, rowIndex, formatExtraData) {
    //     const userType = row.userType.match('bus') ? row.userType.match('bus') + ' Driver' : row.userType
    //     console.log(userType)
    //     return (
    //         <>
    //             {userType}
    //         </>
    //     );
    // }

    const columns = [
        { 
            dataField: 'userName', 
            text: 'Full Name', 
            sort: true,
            headerStyle: { textAlign: 'center' }, 
            style: { textAlign: 'center' }
        },
        { 
            dataField: 'userID', 
            text: 'User ID', 
            sort: true, 
            headerStyle: { textAlign: 'left' }, 
            style: { textAlign: 'left' }
        },
        { 
            dataField: 'userType', 
            text: 'User Type',
            sort: true,
            headerStyle: { textAlign: 'center' }, 
            style: { 
                textAlign: 'center',
                textTransform: 'capitalize'
            },
            // formatter: userTypeFormatter
        },
        { 
            dataField: 'userIC', 
            text: 'ID Number', 
            sort: true,
            headerStyle: { textAlign: 'center' }, 
            style: { textAlign: 'center' }
        },
        { 
            dataField: 'userPhone', 
            text: 'Phone Number', 
            sort: true,
            headerStyle: { textAlign: 'center' }, 
            style: { textAlign: 'center' },
            formatter: (cell,row) => {
                return <Fragment>{row.userPhone.replace(/\+/g, "")}</Fragment>
            }
        },
        { 
            dataField: 'userEmail', 
            text: 'Email Address', 
            sort: true,
            headerStyle: { textAlign: 'center' }, 
            style: { textAlign: 'center' }
        }
    ]

    const { SearchBar, ClearSearchButton } = Search;

    const { ToggleList } = ColumnToggle;

    const ExportCSVButton = (props) => {
        const handleClick = () => {
            props.onExport();
        };

        return (
            <Button 
                variant='success' 
                onClick={handleClick} 
                style={{ float: 'right'}}
            >
                Export to CSV
            </Button>
        );
    };
    
    return (
        <Fragment>
            <ToolkitProvider
                keyField='id'
                data={users}
                columns={columns}
                columnToggle
                search
                exportCSV={{
                    fileName: 'userdetailsreport.csv'
                }}
            >
            {
                props => (
                <div style={{marginTop: '10px'}}>
                    <SearchBar { ...props.searchProps } />
                    <ClearSearchButton { ...props.searchProps } />
                    <ExportCSVButton { ...props.csvProps } />
                    <hr />
                    <div><strong>Display Options</strong></div>
                    <ToggleList
                        contextual='outline-primary'
                        btnClassName='toggle-column-btn-custom-class'
                        { ...props.columnToggleProps } 
                    />
                    <BootstrapTable
                        classes='infohub-table'
                        bordered={false}
                        { ...props.baseProps }
                        pagination={paginationFactory()}
                        headerWrapperClasses='infohub-header'
                        noDataIndication='List is empty.'
                    />
                </div>
                )
            }
            </ToolkitProvider>
        </Fragment>
    );
};

export default Reports;
